<template>
  <el-table v-loading="isLoading" :data="tableData" border>
    <el-table-column label="审批角色名称" prop="approveName" align="left" show-overflow-tooltip />
    <el-table-column label="审批人名称" prop="approveUserInfo" align="left" show-overflow-tooltip />
  </el-table>
</template>
<script>
import { getNextApprover } from '@/API/international';

export default {
  name: 'WhoIsNextApprover',
  props: {
    flowId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isLoading: false,
      tableData: []
    };
  },
  methods: {
    // 获取下一个审批人
    getNextApprover () {
      // 清空之前的数据
      this.tableData = [];
      this.isLoading = true;
      getNextApprover(this.flowId).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data;
        }
      }).catch(() => {
        this.$message.error('获取下一个审批人失败');
      }).finally(() => {
        this.isLoading = false;
      });
    }
  },
  watch: {
    flowId: {
      handler (val) {
        if (val) {
          this.getNextApprover();
        }
      },
      immediate: true
    }
  }
};
</script>

<style scoped lang="scss">
:deep(.el-table__cell) {
  font-size: 14px;
}
</style>
